import { Flex, Spin, Tabs, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { ProductService } from '@services/ProductService'

import { UserService } from '../../../services/UserService'
import type { MultiFactorInfo, Product, User } from '../../../types'

import { AdditionalInfoTab } from './tabs/AdditionalInfoTab/AdditionalInfoTab'
import { DangerZoneTab } from './tabs/DangerZoneTab/DangerZoneTab'
import { DetailsTab } from './tabs/DetailsTab/DetailsTab'

export const UserDetailsPage = () => {
    const [user, setUser] = useState<User>()
    const [products, setProducts] = useState<Product[]>([])
    const [mfaInfo, setMFAInfo] = useState<MultiFactorInfo[] | undefined>()

    const { userId } = useParams()

    const fetch = async () => {
        try {
            const results = await UserService.get(userId!)
            const pResultes = await ProductService.list()
            const mfaInfo = await UserService.listMFA(userId!)

            setUser(results)
            setProducts(pResultes)
            setMFAInfo(mfaInfo)
        } catch (err) {
            console.error('Error retrieving user information', err)
        }
    }

    useEffect(() => {
        if (userId) {
            fetch()
        }
    }, [userId])

    if (!user) {
        return <Spin />
    }

    return (
        <Flex gap="middle" vertical>
            <Typography.Title>
                User {user?.firstName} {user?.lastName}
            </Typography.Title>
            <Tabs style={{ padding: '20px' }}>
                <Tabs.TabPane tab="User Details" key="details">
                    <DetailsTab user={user} products={products} mfaInfo={mfaInfo} refetch={fetch} />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Additional Info" key="additional-info">
                    <AdditionalInfoTab />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Danger Zone" key="danger-zone">
                    <DangerZoneTab user={user} refetch={fetch} />
                </Tabs.TabPane>
            </Tabs>
        </Flex>
    )
}
